import { useEffect, useState } from "react";
import { sanatiseStr } from "utils/sanatiseString";

export const useShowCasePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>();

  // Fetch Data from the page DOM + store in state
  useEffect(() => {
    const getData = () => {
      const jsonData =
        document.querySelector("#showcase-data script")?.textContent || "";
      setData(jsonData ? JSON.parse(sanatiseStr(jsonData)) : "");
      setLoading(false);
    };
    getData();

    return () => {
      setData({});
    };
  }, [setData, setLoading]);

  // Build an index of Filter Prop keys
  const filtersIndex =
    data && Object.keys(data).filter((key) => key.includes("Filter"));

  // Build an object from *filterIndex* Array
  let filtersCollection = {};
  filtersIndex &&
    filtersIndex.forEach((key) => (filtersCollection[key] = data[key]));

  // Destructure used content from JSON:
  const {
    HeroSectionTitle = null,
    OgTitle = null,
    HeroSectionSuperscript = null,
    HeroSectionBlockOverlayColor = null,
    FeaturedSubpages = null,
    InitialSubpages = null,
    ShowLayoutToggle = null,
    Slide1 = null,
    Slide2 = null,
    Slide3 = null,
    ShowPublicationDateReadTimeContentType = null
  } = data || {};

  return {
    loading,
    OgTitle,
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    FeaturedSubpages,
    InitialSubpages,
    FiltersCollection: filtersCollection,
    ShowLayoutToggle,
    Slides: [Slide1, Slide2, Slide3],
    ShowPublicationDateReadTimeContentType
  };
};
